import { Component, Output, EventEmitter } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ConfirmationService } from 'primeng/api';
import { Lightbox } from 'ngx-lightbox';

@Component({
  template: `
    <button
      *ngIf="params.allowSelect"
      type="button"
      class="btn btn-block btn-success btn-simple btn-sm"
      (click)="onSelect()"
    >
      Select
    </button>
    <button type="button" class="btn btn-block btn-primary btn-simple btn-sm" (click)="onOpen()">
      View
    </button>
    <button type="button" class="btn btn-block btn-danger btn-simple btn-sm" (click)="onDelete()">
      Delete
    </button>
  `,
})
export class ImageLinksComponent implements AgRendererComponent {
  params: any;

  constructor(public confirmationService: ConfirmationService, public lightbox: Lightbox) {}

  agInit(params: any): void {
    this.params = params;
    // console.log('image links params', this.params);
    // console.log('agInit', this.params.context.componentParent);
  }

  refresh(params: any): boolean {
    return false;
  }

  onOpen(): void {
    console.log('open image', this.params.data);

    const image = {
      imageData: this.params.data,
      imageUrl: this.params.data.imageUrl,
      src: this.params.data.imageUrl,
      thumb: this.params.data.imageUrl,
    };

    this.lightbox.open([image], 0, {
      centerVertically: true,
      disableScrolling: true,
      showImageNumberLabel: true,
    });

    // const image_window = window.open(this.params.data.imageUrl);
  }
  onDelete(): void {
    // console.log('delete image', this.params.data);

    this.confirmationService.confirm({
      message:
        'Are you sure that you want to delete this image? It will be completely removed from the system',
      accept: () => {
        // console.log('DELETE');
        this.params.context.componentParent.deleteImage(this.params.data);
      },
    });
  }

  onSelect(): void {
    this.params.context.componentParent.selectImage(this.params.data);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ag-grid/image-links.component.ts